// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import FormOutlined from '/home/pxj/xsn_d/worktrees/mcp-service-crm/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/@ant-design/icons/es/icons/FormOutlined';
import CalendarOutlined from '/home/pxj/xsn_d/worktrees/mcp-service-crm/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/@ant-design/icons/es/icons/CalendarOutlined';
export default { FormOutlined, CalendarOutlined };
